<div [ngClass]="{'urgent-header': urgent, 'normal-header': !urgent}">
    <div class="d-flex justify-content-between">
        <div>{{headerId | translate}}</div>
        <div>{{countLabelId | translate: {count: requestCount} }} </div>
    </div>
    <hr class="pb-3">
</div>